export default __webpack_public_path__ + "static/arattai_logo-51d013dad0936f114fc3408191ea99dc.png";